import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { memo, useContext, useEffect, useState } from "react";
import { createUseStyles, useTheme } from "react-jss";
import ChatBot from "react-simple-chatbot";
import { v4 as uuidv4 } from "uuid";
import { postCustomerSetState, qnaStateTypes, useAuth } from "../../../core";
import { ErrorBox } from "../../atoms";
import { BotContext } from "../../context/BotContext";
import { Footer } from "../../footer/footer";
import { ButtonAnswer } from "./ButtonAnswer";
import { History } from "./history/History";
import { QuestionBubble } from "./history/QuestionBubble";

import classNames from "classnames";
import { isMobile } from "react-device-detect";
import { useMutation } from "react-query";
import { useQnaState } from "../../../core/hooks/useQnaState";
import { AnswerComponent } from "../../molecule/AnswerComponent";
import { QuestionComponent } from "../../molecule/QuestionComponent";
import Question from "../../../assets/images/question.svg";
import Arrow from "../../../assets/images/arrow-down.svg";

const { isSaderatCustomization } = JSON.parse(sessionStorage.getItem("config"));

const useStyles = createUseStyles((theme) => ({
  floatingBtn: {
    width: 32,
    height: 32,
    position: "absolute",
    borderRadius: "100%",
    direction: "rtl",
    border: "none!important",
    zIndex: "1001",
    bottom: 106,
    left: 16,
    padding: 0,
    boxShadow: "0px 4px 4px 0px #B0B2B647",
    "& $img": {
      width: 16,
      height: 16,
    },
  },
  endBtn: {
    height: 32,
    position: "absolute",
    borderRadius: 100,
    direction: "rtl",
    border: "none!important",
    zIndex: "1001",
    bottom: 106,
    left: 16,
    padding: "0 18px",
    background: "#FB372B",
    boxShadow: "0px 4px 4px 0px #FB372B2B",
    color: "white",
    cursor: "pointer",
  },
  helpButtonColor: {
    background: "white",
  },
  jumpButton: {
    position: "absolute",
    borderRadius: "50%",
    direction: "rtl",
    color: `${theme.jumpBtnColor}!important`,
    border: "none",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: "1000",
    fontSize: 12,
    "& span": { marginRight: 2 },
    bottom: 117,
    right: "20px",
    cursor: "pointer",
    background: theme.jumpBtnBg,
    padding: 15,
    width: 40,
    height: 40,
  },

  "@media screen and (min-width: 688px) ": {
    container: {
      width: process.env.REACT_APP_PROJECT === "widget" ? "100%" : 688,
    },
    powerBy: {
      width: "650px",
    },
    floatingBtn: {
      bottom: 122,
      width: 40,
      height: 40,
      "& $img": {
        width: 20,
        height: 20,
      },
    },
    endBtn: {
      bottom: 122,
      height: 40,
    },
  },

  "@media screen and (max-width: 687px) ": {
    container: {
      width: "100%",
      "& .rsc-input": {
        borderRadius: " 0 !important",
      },
    },
    powerBy: {
      width: "calc(100% - 27px)",
    },
  },
  container: {
    height: "100%",
    margin: "auto",
    position: "relative",
    "& .rsc-ts-bubble": {
      backgroundColor: `${
        isSaderatCustomization
          ? theme.answerBubbleBgSaderat
          : theme.answerBubbleBg
      }!important`,
      textAlign: "right",
      // fontSize: "16px!important",
      color: `${theme.answerBubbleColor}!important`,
      maxWidth: "70%!important",
      overflow: "visible",
    },
    "& .rsc-ts-image": {
      backgroundColor: theme.avatarBg,
    },
  },
}));

const Bot = memo((props) => {
  const { error, headerComponent } = props;
  const theme = useTheme();
  const styles = useStyles({ theme });
  const [botKey, setBotKey] = useState(uuidv4());
  const { user } = useAuth();
  const {
    globalProps,
    setButtonProps,
    selectedRoom,
    historyUser,
    inputRef,
    askedQusetions,
    setAskedQuestions,
    rooms,
    // isBotMode,
    // setIsBotMode
    chatStateMode,
    setChatStateMode,
  } = useContext(BotContext);

  useQnaState(globalProps);

  const [jumpBtnVisible, setJumpBtnVisible] = useState(false);
  const handlehelp = () => {
    const q = {
      question: "/help",
      label_question: "کمک",
    };
    askedQusetions.splice(1, 0, q);

    setAskedQuestions(askedQusetions);
    setButtonProps(q);
    globalProps.triggerNextStep({
      value: q,
      trigger: "5",
    });
  };

  const handleJumpDown = (node) => {
    node?.scrollTo({ behavior: "smooth", top: node.scrollHeight });
    !isMobile && inputRef.current.focus();
  };
  useEffect(() => {
    if (error) {
      globalProps?.triggerNextStep({
        trigger: "error",
        value: error,
      });
    } else {
      globalProps?.triggerNextStep({
        trigger: "1",
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error]);

  useEffect(() => {
    const scrollHandler = (_) => {
      const rscContent = document.getElementsByClassName("rsc-content")[0];
      const scrollH = rscContent?.scrollTop;
      const height = rscContent?.scrollHeight - rscContent?.clientHeight;
      if (height - scrollH < 2) {
        setJumpBtnVisible(false);
      } else {
        setJumpBtnVisible(true);
      }
    };

    window.addEventListener("scroll", scrollHandler, true);
    return () => {
      window.removeEventListener("scroll", scrollHandler, true);
    };
  }, []);
  useEffect(() => {
    setBotKey(uuidv4());
  }, [selectedRoom, historyUser]);
  const { mutate: setStateToBTC } = useMutation(
    async () => {
      const { data } = await postCustomerSetState({
        state: qnaStateTypes.BTC,
        customer_id: user.cellnum,
        room_id: selectedRoom?.name,
      });
      return data;
    },
    {
      onSuccess: ({ data, status }) => {
        if (status) {
          setChatStateMode(qnaStateTypes.BTC);
        }
      },
    }
  );
  const handleNewAnswer = () => {
    setTimeout(() => {
      const node = document.getElementsByClassName("rsc-content")[0];
      if (node) {
        handleJumpDown(node);
      }
    }, 100);
  };

  const handleNewQuestion = () => {
    const node = document.getElementsByClassName("rsc-loading")[0];
    console.log(node);
    if (node) {
      node.scrollIntoView();
    }
  };

  return (
    <div className={styles.container}>
      {chatStateMode !== undefined &&
        (chatStateMode === qnaStateTypes.BTC ? (
          <button
            className={classNames(styles.floatingBtn, styles.helpButtonColor)}
            onClick={handlehelp}
            id="helpButton"
            disabled={historyUser || rooms?.length === 0}
          >
            <img alt="help" src={Question} />
          </button>
        ) : (
          <button
            className={styles.endBtn}
            onClick={setStateToBTC}
            id="endLivechatButton"
          >
            پایان مکالمه با کارشناس
          </button>
        ))}
      {jumpBtnVisible && (
        <div
          id="jumpButton"
          className={styles.jumpButton}
          onClick={() =>
            handleJumpDown(document.getElementsByClassName("rsc-content")[0])
          }
        >
          <img alt="bottom" src={Arrow} />
        </div>
      )}
      <Footer />
      <ChatBot
        key={botKey}
        enableMobileAutoFocus={false}
        headerComponent={headerComponent}
        style={{
          margin: "auto",
          width: "100%",
        }}
        contentStyle={{
          paddingTop: 0,
        }}
        customStyle={{
          background: "none",
          boxShadow: "none",
          justifyContent: "flex-end",
          margin: 0,
          padding: 0,
          flexDirection: "column",
          fontSize: "16px!important",
        }}
        hideUserAvatar={true}
        customDelay={0}
        userDelay={0}
        steps={[
          {
            id: "1",
            component: <History error={error} />,
            delay: false,
          },
          {
            id: "5", //bot question
            component: <QuestionBubble handleNewQuestion={handleNewQuestion} />,
            trigger: "6",
            delay: 0,
          },
          {
            id: "6", //bot answer
            component: <ButtonAnswer handleNewAnswer={handleNewAnswer} />,
            waitAction: true,
            // asMessage: true,
            delay: 0,
          },
          {
            id: "lvA", //live chat answer
            component: <AnswerComponent />,
            waitAction: true,
            // asMessage: true,
            delay: 0,
          },
          {
            id: "lvQ", //live chat question
            component: <QuestionComponent />,
            delay: 0,
          },
          {
            id: "error",
            component: <ErrorBox error={error} />,
            end: true,
          },
        ]}
      />
    </div>
  );
});

export { Bot };
